import BaseService from './base.service'

import { sortTree } from '../utils/functions'

class MapsService  extends BaseService {
    async getTreeData(folderId) {
        const url = folderId ? '/api/v1/maps/tree?folderId='+folderId : '/api/v1/maps/tree';
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const data = await response.json()
        sortTree(data)
        return data
    }

    async getMaps(folderId) {
        const response = await fetch(
            `/api/v1/maps/tree/folder/files?folderId=${folderId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }
        )
        const data = await response.json()
        return data.files
    }

    async deleteMap(mapId) {
        const response = await fetch(`/api/v1/maps/file/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fileId: mapId }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }

    async getMaps(folderId) {
        const response = await fetch(
            `/api/v1/maps/tree/folder/files?folderId=${folderId}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'same-origin',
            }
        )
        this.handleHttpErrors(response)
        const data = await response.json()
        console.log('Data: ', data)
        return data.files
    }

    async searchMaps(criteria) {
        const response = await fetch(
            `/api/v1/maps/search`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    searchCriteria: criteria
                }),
                credentials: 'same-origin',
            }
        )
        this.handleHttpErrors(response)
        const data = await response.json()

        return data.rows;
    }
    async moveFolder(srcFolderId, targetFolderId) {
        const response = await fetch(`/api/v1/maps/folder/paste`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pasteFolderId: targetFolderId,
                cutFolderId: srcFolderId,
            }),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async moveFiles(srcFileIds, targetFolderId) {
        const response = await fetch(`/api/v1/maps/file/paste`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pasteFolderId: targetFolderId,
                cutFileId: srcFileIds[0],
            }),
            credentials: 'same-origin',
        })

        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async generateFileSharedLink(documentId) {
        const response = await fetch(`/api/v1/maps/file/share/generatelink`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fileId: documentId }),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async saveFolderSecurity(folderId, folderPath, securityDetail) {
        const response = await fetch(`/api/v1/maps/folder/security/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId,
                folderPath: folderPath,
                securityDetail: JSON.stringify(securityDetail),
            }),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async saveStyles(folderId, folderPath, iconColor, textStyle, textSize) {
        const body = {
            folderId: folderId,
            folderPath: folderPath,
            stateColor: iconColor,
            boldText: textStyle.includes('bold') ? 'on' : undefined,
            italicText: textStyle.includes('italic') ? 'on' : undefined,
            textSize: textSize,
        }

        const response = await fetch(`/api/v1/maps/folder/properties/save`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async saveFolderComments(folderId, comments) {
        const body = {
            folderId: folderId,
            comments: comments,
        }

        const response = await fetch(`/api/v1/maps/folder/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async saveFileComments(fileId, comments) {
        const body = {
            fileId: fileId,
            comments: comments,
        }

        const response = await fetch(`/api/v1/maps/file/comments`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            credentials: 'same-origin',
        })
        this.handleHttpErrors(response)
        const rsp = await response.json()

        return rsp
    }

    async saveFolder(folder, folderPath) {
        const response = await fetch(`/api/v1/maps/tree/folder`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ folder: folder, folderPath: folderPath }),
            credentials: 'same-origin',
        })

        const folders = await response.json()
        console.log('saveFolder: rsp ', folders)
        return folders[0]
    }

    async deleteFolder(folderId) {
        const response = await fetch(`/api/v1/maps/folder/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                folderId: folderId
            }),
            credentials: 'same-origin',
        })

        const rsp = await response.json()

        return rsp
    }
}

const mapsService = new MapsService()

export default mapsService